import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CloseButton from '../atoms/CloseButton';

const styles = {
  message: {
    whiteSpace: 'pre-wrap'
  }
};

const enhance = compose();

const Main = enhance(({ classes, openContent, updateOpenContent, content }) => {
  const cancelAction = () => updateOpenContent(false);
  return (
    <Dialog
      open={openContent}
      onClose={() => {
        updateOpenContent(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.message}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CloseButton onClickAction={cancelAction} color="default" />
      </DialogActions>
    </Dialog>
  );
});

export default withRouter(withStyles(styles)(Main));
